var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 17,
    viewBox: "0 0 108 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8848 2.86963H28.8947V3.98962H24.2048V7.25958H28.1548V8.37958H24.2048V12.1696H29.0547V13.2896H22.8848V2.84961V2.86963Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7051 9.44873C31.7051 6.93873 33.2851 5.37872 35.0451 5.37872C35.9451 5.37872 36.5351 5.71875 37.2151 6.27875L37.1551 4.94873V1.96875H38.4651V13.2988H37.3851L37.2751 12.3887H37.2351C36.6351 12.9887 35.8151 13.4888 34.8851 13.4888C32.9551 13.4888 31.7051 12.0187 31.7051 9.44873ZM37.1551 11.3387V7.28876C36.4951 6.69876 35.9051 6.48877 35.2751 6.48877C34.0351 6.48877 33.0551 7.67878 33.0551 9.43878C33.0551 11.2888 33.8251 12.3987 35.1751 12.3987C35.8851 12.3987 36.5051 12.0488 37.1551 11.3488V11.3387Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1152 3.13879C42.1152 2.62879 42.5153 2.29883 43.0153 2.29883C43.5153 2.29883 43.9153 2.62879 43.9153 3.13879C43.9153 3.64879 43.5253 3.97882 43.0153 3.97882C42.5053 3.97882 42.1152 3.62879 42.1152 3.13879ZM42.3553 5.5788H43.6653V13.3088H42.3553V5.5788Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7653 10.9084V6.63843H46.6152V5.64844L47.8253 5.56842L47.9853 3.39844H49.0753V5.56842H51.1653V6.63843H49.0753V10.9385C49.0753 11.8885 49.3752 12.4285 50.2752 12.4285C50.5452 12.4285 50.9052 12.3284 51.1552 12.2184L51.4052 13.2084C50.9752 13.3584 50.4553 13.4985 49.9753 13.4985C48.3353 13.4985 47.7752 12.4585 47.7752 10.9185L47.7653 10.9084Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.635 5.57867H59.715L59.825 6.46869H59.865C60.565 5.88869 61.435 5.38867 62.325 5.38867C64.325 5.38867 65.385 6.93867 65.385 9.32867C65.385 11.9587 63.805 13.4987 62.035 13.4987C61.325 13.4987 60.605 13.1687 59.895 12.5987L59.935 13.9487V16.5687H58.625V5.57867H58.635ZM64.045 9.32867C64.045 7.61867 63.465 6.4787 62.005 6.4787C61.355 6.4787 60.695 6.83869 59.935 7.52869V11.5787C60.635 12.1687 61.305 12.3787 61.815 12.3787C63.095 12.3787 64.035 11.2287 64.035 9.31866L64.045 9.32867Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7346 5.57867H69.8146L69.9246 6.98871H69.9646C70.5046 6.00871 71.2946 5.38867 72.1646 5.38867C72.5046 5.38867 72.7446 5.42871 72.9946 5.54871L72.7446 6.69867C72.4746 6.61867 72.3046 6.56866 71.9946 6.56866C71.3446 6.56866 70.5646 7.03869 70.0346 8.34869V13.3087H68.7246V5.57867H68.7346Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7852 9.44891C74.7852 6.86891 76.4751 5.37891 78.3651 5.37891C80.2551 5.37891 81.9452 6.86891 81.9452 9.44891C81.9452 12.0289 80.2551 13.489 78.3651 13.489C76.4751 13.489 74.7852 11.9989 74.7852 9.44891ZM80.6052 9.44891C80.6052 7.67891 79.7052 6.46893 78.3752 6.46893C77.0452 6.46893 76.1451 7.67891 76.1451 9.44891C76.1451 11.2189 77.0452 12.4089 78.3752 12.4089C79.7052 12.4089 80.6052 11.2289 80.6052 9.44891Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3848 5.64929L85.4948 5.56927H88.3848V6.63928H84.3848V5.64929ZM85.4348 4.3493C85.4348 2.7793 86.1448 1.7793 87.6948 1.7793C88.1648 1.7793 88.6248 1.89932 88.9748 2.04932L88.6948 3.04932C88.4048 2.90932 88.0948 2.8493 87.8148 2.8493C87.0848 2.8493 86.7248 3.35931 86.7248 4.35931V13.2993H85.4148V4.3493H85.4348Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8945 3.13879C90.8945 2.62879 91.2846 2.29883 91.7946 2.29883C92.3046 2.29883 92.6945 2.62879 92.6945 3.13879C92.6945 3.64879 92.3046 3.97882 91.7946 3.97882C91.2846 3.97882 90.8945 3.62879 90.8945 3.13879ZM91.1346 5.5788H92.4445V13.3088H91.1346V5.5788Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3252 11.7485V1.97852H97.6352V11.8485C97.6352 12.2485 97.8052 12.4085 98.0052 12.4085C98.0852 12.4085 98.1452 12.4085 98.2952 12.3785L98.4752 13.3785C98.2852 13.4485 98.0652 13.4985 97.7252 13.4985C96.7452 13.4985 96.3452 12.8785 96.3452 11.7585L96.3252 11.7485Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.074 9.44891C101.074 6.92891 102.774 5.37891 104.544 5.37891C106.514 5.37891 107.624 6.79891 107.624 9.00891C107.624 9.28891 107.604 9.55896 107.564 9.74896H102.354C102.444 11.389 103.444 12.4489 104.924 12.4489C105.664 12.4489 106.274 12.2089 106.844 11.8289L107.314 12.689C106.634 13.129 105.814 13.489 104.764 13.489C102.704 13.489 101.064 11.9789 101.064 9.44891H101.074ZM106.474 8.81891C106.474 7.26891 105.774 6.42896 104.564 6.42896C103.474 6.42896 102.504 7.29891 102.344 8.81891H106.464H106.474Z",
    fill: "#4CC8EF",
    stroke: "#8DD6EF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.565 2.05859H0.375",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4354 13.5684L0.275391 13.5984",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 13.6785L0.705017 1.89844",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 13.6886C12.0659 11.3986 12.0659 8.90859 12.0759 6.55859V13.6886Z",
    fill: "#4CC8EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0759 13.6886C12.0659 11.3986 12.0659 8.90859 12.0759 6.55859",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96582 7.50018L11.6858 0.660156",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 9.16034L13.345 2.32031",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50586 10.4092C4.00586 9.41924 4.50585 8.42922 4.99585 7.44922L3.50586 10.4092Z",
    fill: "#4CC8EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50586 10.4092C4.00586 9.41924 4.50585 8.42922 4.99585 7.44922",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70544 9.10938L3.31543 10.5994",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5557 2.41943L11.5957 0.439453",
    stroke: "#8DD6EF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.974d5de8911cc40f2288e5dffe3fe75e.svg";
export { ForwardRef as ReactComponent };